import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { RootState } from '../../../redux/root';
import { setPermittingPristine, setSelectedJurisdiction } from '../../../redux/slices/wikiSlice';
import SubmissionChip from './SubmissionChip';
import { isMultiChecked, toggleMulti } from './submissionStorage';

const OPTIONS = [
  { value: 'full', label: 'Full' },
  { value: 'partial', label: 'Partial' },
  { value: 'inPerson', label: 'In Person' },
];

const OnlineSub = () => {
  const selectedJurisdiction = useSelector((s: RootState) => s.wikiSlice.selectedJurisdiction);
  const dispatch = useDispatch();
  const raw = selectedJurisdiction?.permitting?.onlineSub;

  const onToggle = (value: string) => {
    dispatch(setPermittingPristine(false));
    dispatch(
      setSelectedJurisdiction({
        ...selectedJurisdiction,
        permitting: {
          ...selectedJurisdiction.permitting,
          onlineSub: toggleMulti(raw, value),
        },
      }),
    );
  };

  return (
    <Section>
      <SectionHeader>Online Sub</SectionHeader>
      <ChipRow>
        {OPTIONS.map(opt => (
          <SubmissionChip
            key={opt.value}
            label={opt.label}
            checked={isMultiChecked(raw, opt.value)}
            onToggle={() => onToggle(opt.value)}
          />
        ))}
      </ChipRow>
    </Section>
  );
};

export default OnlineSub;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--neutral-0);
`;

const SectionHeader = styled.div`
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--neutral-600);
`;

const ChipRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`;
